import { render, staticRenderFns } from "./list.vue?vue&type=template&id=61baf9fe&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=61baf9fe&scoped=true&lang=scss"
import style1 from "./list.vue?vue&type=style&index=1&id=61baf9fe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61baf9fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61baf9fe')) {
      api.createRecord('61baf9fe', component.options)
    } else {
      api.reload('61baf9fe', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=61baf9fe&scoped=true", function () {
      api.rerender('61baf9fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/purchase/purchaseForm/list.vue"
export default component.exports